export default __webpack_public_path__ + "static/media/5.b77c286f.png";